// extracted by mini-css-extract-plugin
module.exports = {"author":"styles-m__author__31KAs"};